module.exports = __webpack_public_path__ + "img/yingyong22.cb145f27.webp";